import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { ShowToast } from '../../common/Toastr';
import CustomPagination from "../../common/Pagination";
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../common/GlobalSlice';
import { getTaskRequestHoursAsync,updateAccountProjectTaskId } from "./taskRequestHoursSlice";
import { useNavigate } from 'react-router-dom';
import { getPageSizeArray, getValueFromResource } from '../../common/timeLiveFunction';
import { getFilteredList } from '../../common/timeLiveFunction';
import TaskRequestHoursForm from "./TaskRequestHoursForm";
import TaskRequestHoursItem from "./TaskRequestHoursItem";

import Loader from "../../common/Loader";
import { KTIcon } from "../../_metronic/helpers";
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


const TaskRequestHours = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { obj } = location.state || {};
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { pageId, menuList,IsAdd,IsList } = useAppSelector((state) => state.globalState);
    const { taskRequestHoursList, isReload,isLoading, selectedRecord, accountprojecttaskid } = useAppSelector((state) => state.taskRequestHours);
    let AccountProjectTaskId = 0;
    if (obj !== undefined) {
        AccountProjectTaskId = obj.AccountProjectTaskId;
        dispatch(updateAccountProjectTaskId(AccountProjectTaskId));
    }    
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const navigate = useNavigate();
   

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const filteredData: any = getFilteredList(taskRequestHoursList, searchTerm);
    const isAnyPending = taskRequestHoursList.some(item => item.Status === 'Pending');
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = taskRequestHoursList.length;
    const recordsFiltered = filteredData.length;
  
    useEffect(() => {
        if (isReload) {
            dispatch(getTaskRequestHoursAsync(AccountProjectTaskId));
        }
    }, [isReload, AccountProjectTaskId]);

    useEffect(() => {
        dispatch(getTaskRequestHoursAsync(AccountProjectTaskId));
    }, [dispatch])

    const handleOnClickEvent = () => {     
        setIsModalOpen(true);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    return (
        <> 
        {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Task Request List')} */}
                        {getValueFromResource('Task Request List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px' }}
                                disabled={isAnyPending}
                            >
                               {/* <KTIcon iconName='plus' className='fs-3' /> */}
                               {/* {t('Add Task Request')} */}
                               {getValueFromResource('Add Task Request',dispatch, t)}
                            </button>
                        }
                        </div>
                </div>
                {IsList &&
                    <div className="card-body">
                        <div className="table-responsive">
                            <TaskRequestHoursItem taskRequestHoursList={currentItems} modelRef={modelRef} t={t} onopenModal={openModal} oncloseModal={closeModal} />
                        </div>
                    </div>
                }
            </div>
            {isModalOpen &&
                 <TaskRequestHoursForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
        </>
    )

}

export default TaskRequestHours;